__turbopack_context__.v({
  "bodyText": "IkadRenewal-module__Dz9iBW__bodyText",
  "collectionSection": "IkadRenewal-module__Dz9iBW__collectionSection",
  "contactItem": "IkadRenewal-module__Dz9iBW__contactItem",
  "contactLabel": "IkadRenewal-module__Dz9iBW__contactLabel",
  "contactList": "IkadRenewal-module__Dz9iBW__contactList",
  "contactSection": "IkadRenewal-module__Dz9iBW__contactSection",
  "container": "IkadRenewal-module__Dz9iBW__container",
  "deadlineNote": "IkadRenewal-module__Dz9iBW__deadlineNote",
  "docsItem": "IkadRenewal-module__Dz9iBW__docsItem",
  "docsLabel": "IkadRenewal-module__Dz9iBW__docsLabel",
  "docsList": "IkadRenewal-module__Dz9iBW__docsList",
  "docsNumber": "IkadRenewal-module__Dz9iBW__docsNumber",
  "docsSection": "IkadRenewal-module__Dz9iBW__docsSection",
  "dot": "IkadRenewal-module__Dz9iBW__dot",
  "formButton": "IkadRenewal-module__Dz9iBW__formButton",
  "inlineLink": "IkadRenewal-module__Dz9iBW__inlineLink",
  "notesSection": "IkadRenewal-module__Dz9iBW__notesSection",
  "overviewSection": "IkadRenewal-module__Dz9iBW__overviewSection",
  "repNote": "IkadRenewal-module__Dz9iBW__repNote",
  "resourceLink": "IkadRenewal-module__Dz9iBW__resourceLink",
  "resourcesList": "IkadRenewal-module__Dz9iBW__resourcesList",
  "resourcesSection": "IkadRenewal-module__Dz9iBW__resourcesSection",
  "section": "IkadRenewal-module__Dz9iBW__section",
  "sectionSubtitle": "IkadRenewal-module__Dz9iBW__sectionSubtitle",
  "simpleItem": "IkadRenewal-module__Dz9iBW__simpleItem",
  "simpleList": "IkadRenewal-module__Dz9iBW__simpleList",
  "subTitle": "IkadRenewal-module__Dz9iBW__subTitle",
  "title": "IkadRenewal-module__Dz9iBW__title",
  "warningNote": "IkadRenewal-module__Dz9iBW__warningNote",
  "yearlyNote": "IkadRenewal-module__Dz9iBW__yearlyNote",
});
